import './ProjectsDetail.scss';
import Section from "../../modules/section/Section";
import Picture from "../../atoms/picture/Picture";
import ProjectsDetailData from "./ProjectsDetailData.json";
import {useEffect, useState} from "react";
import AtmLink from "../../atoms/atmLink/AtmLink";
import {ENUMS} from "../../../enums/enums";
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";

const ProjectsDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const project = ProjectsDetailData.projects.find((project) => project.id === id);
  const [mainImages, setMainImages] = useState(null);
  const [teamImages, setTeamImages] = useState(null);
  const [teamImagesMobile, setTeamImagesMobile] = useState(null);

  useEffect(() => {
    if (project) {
      Promise.all([import(`../../../assets/images/${project.image}`), import(`../../../assets/images/${project.imageMobile}`)])
        .then((data) => {
          setMainImages(data);
        });

      if (project.team) {
        const promisesTeamsDesktop = [];
        const teamImagesArray = project.team.map((a) => a.image);
        teamImagesArray.forEach((image) => promisesTeamsDesktop.push(import(`../../../assets/images/${image}`)));

        const promisesTeamsMobile = [];
        const teamImagesMobileArray = project.team.map((a) => a.imageMobile);
        teamImagesMobileArray.forEach((image) => promisesTeamsMobile.push(import(`../../../assets/images/${image}`)));

        Promise.all(promisesTeamsDesktop)
          .then((data) => {
            setTeamImages(data);
          });
        Promise.all(promisesTeamsMobile)
          .then((data) => {
            setTeamImagesMobile(data);
          });
      }
    }
  }, [project]);

  if (!project) {
    return <h2 className="container mb-sm">{t("noPage")}</h2>
  }

  return (
    <>
      <Section twoColumn container>
        <div className={'project-detail__left'}>
          <h5>
            {t(project.superTitle)}
          </h5>
          <h3>{t(project.title)}</h3>
          <p>{t(project.mainDescription)}</p>
          {project.secondaryDescription && <p>{t(project.secondaryDescription)}</p>}
        </div>

        <div className={'project-detail__right'}>
          <div className={'project-detail__right-main-image'}>
            {mainImages && <Picture srcDesktop={mainImages[0].default} srcMobile={mainImages[1].default}/>}
          </div>
          {project.team &&
            <div className={'project-detail__team'}>
              <h3 className={'project-detail__team-title'}>{t("team")}</h3>
              <div className={'project-detail__team-container'}>
                {project.team.map((member, index) => {
                  return (
                    <AtmLink noStyle to={`/${ENUMS.ROUTE_OUR_PEOPLE}/${member.id}`} className={"project-detail__team-member"} key={member.name}>
                      {teamImages && teamImagesMobile && <Picture src={teamImages[index].default} srcMobile={teamImagesMobile[index].default}/>}
                      <h3>{t(member.name)}</h3>
                      <div className={'text-primary'}>{t(member.role)}</div>
                    </AtmLink>
                  );
                })}
              </div>
            </div>
          }
        </div>
      </Section>
    </>
  )
}

export default ProjectsDetail;